/**
 * js/modules/turnstile.js
 * Module pour la gestion dynamique du captcha Turnstile
 */

/**
 * Initialise le composant Turnstile avec la clé appropriée selon l'environnement
 * @param {string} containerId - ID du conteneur où placer le captcha
 * @param {Function} onLoad - Callback appelé quand le captcha est chargé
 */
export function initTurnstile(containerId, onLoad = null) {
  const container = document.getElementById(containerId);
  if (!container) return;

  // Vérifier si data-sitekey est déjà défini dans le HTML
  const existingSiteKey = container.getAttribute("data-sitekey");

  // Utiliser la clé Turnstile appropriée depuis les variables d'environnement ou l'HTML
  const sitekey = existingSiteKey || import.meta.env.VITE_TURNSTILE_SITEKEY;
  const isTurnstileEnabled = existingSiteKey
    ? true
    : import.meta.env.VITE_TURNSTILE_ENABLED === "true";

  // Si Turnstile est désactivé (en dev), créer un captcha simulé
  if (!isTurnstileEnabled) {
    console.log("Mode développement: Turnstile simulé");
    // Code existant pour la simulation
    return;
  }

  // En production, initialiser le vrai Turnstile
  if (window.turnstile) {
    // Si la clé est déjà dans le HTML, ne pas la réappliquer avec render
    if (!existingSiteKey) {
      window.turnstile.render(container, {
        sitekey: sitekey,
        theme: "light",
        callback: function (token) {
          console.log("Turnstile validé avec succès");
          if (onLoad) onLoad(token);
        },
      });
    }
  } else {
    console.error("Script Turnstile non chargé");
  }
}

/**
 * Charge le script Turnstile conditionnellement selon l'environnement
 */
export function loadTurnstileScript() {
  const isTurnstileEnabled = import.meta.env.VITE_TURNSTILE_ENABLED === "true";

  if (isTurnstileEnabled) {
    // Vérifier si le script est déjà chargé
    if (document.querySelector('script[src*="turnstile"]')) {
      return;
    }

    const script = document.createElement("script");
    script.src =
      "https://challenges.cloudflare.com/turnstile/v0/api.js?onload=onloadTurnstileCallback";
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }
}
